import { ChevronRight, TreePalm } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';

interface TimeOffLabelCellProps {
  isExpanded: boolean;
  onToggle: () => void;
}

/**
 * Left-most label cell of the time-off row (mirrors the project rows' label
 * cell). A clickable button with a palm icon, the "Time off / Reduces
 * availability" copy, and a chevron that rotates to signal the expand state.
 */
export function TimeOffLabelCell({ isExpanded, onToggle }: TimeOffLabelCellProps) {
  const { t } = useTranslation('authenticated.timeTracking');
  return (
    <button
      type="button"
      onClick={onToggle}
      className="flex items-center gap-2.5 border-b bg-time-off-soft/40 px-3 py-3 text-left transition-colors hover:bg-time-off-soft/60"
    >
      <ChevronRight
        className={cn(
          'h-4 w-4 shrink-0 text-time-off-text-soft transition-transform',
          isExpanded && 'rotate-90'
        )}
      />
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md border border-time-off-border bg-time-off-soft text-time-off-text">
        <TreePalm className="h-4 w-4" />
      </div>
      <div className="flex min-w-0 flex-col leading-tight">
        <span className="text-[13.5px] font-semibold text-time-off-text">
          {t('weekView.timeOff.label')}
        </span>
        <span className="text-[11.5px] text-time-off-text-soft">
          {t('weekView.timeOff.sublabel')}
        </span>
      </div>
    </button>
  );
}
